export const GAME_MODE_REGULAR = 'regular' as const;
export const GAME_MODE_PRACTICE = 'practice' as const;
export type GameMode = typeof GAME_MODE_REGULAR | typeof GAME_MODE_PRACTICE;

export const GAME_TYPE_INTRA_SQUAD = 'Intra Squad';

/** Accept only exact `regular` | `practice`. Same contract as the backend. */
export const parseGameMode = (value?: string | null): GameMode =>
  value === GAME_MODE_PRACTICE ? GAME_MODE_PRACTICE : GAME_MODE_REGULAR;

export const normalizeGameMode = parseGameMode;

export const getGameModeLabel = (mode?: string | null): string =>
  parseGameMode(mode) === GAME_MODE_PRACTICE ? 'Practice' : 'Regular';

/** Filter season games for Regular vs Practice (Intra Squad) analytics selectors. */
export const filterGamesByMode = <T extends { type?: string | null }>(
  games: T[],
  mode?: string | null,
): T[] => {
  if (parseGameMode(mode) === GAME_MODE_PRACTICE) {
    return games.filter((g) => g.type === GAME_TYPE_INTRA_SQUAD);
  }
  return games.filter((g) => g.type !== 'Scrimmage' && g.type !== GAME_TYPE_INTRA_SQUAD);
};

/** Leaderboard dropdown label. Dates belong on Regular games only. */
export const formatLeaderboardGameLabel = (
  game: { date?: string | null; opponentName?: string | null; name?: string | null },
  mode?: string | null,
): string => {
  if (parseGameMode(mode) === GAME_MODE_PRACTICE) {
    return (game.name || GAME_TYPE_INTRA_SQUAD).trim();
  }
  const dateStr = game.date ? String(game.date).substring(5, 10) : '';
  return `${dateStr} ${game.opponentName || game.name || 'Game'}`.trim();
};

export const gameDateKey = (dateVal?: string | Date | null): string => {
  if (!dateVal) return '';
  return String(dateVal).slice(0, 10);
};

export const formatIntraSquadGameName = (dateStr?: string, version = 1): string => {
  const n = Number(version);
  const suffix = Number.isFinite(n) && n > 0 ? n : 1;
  return `${GAME_TYPE_INTRA_SQUAD} (${suffix})`;
};
